module.exports = __webpack_public_path__ + "img/1280-px-pay-pal-svg@3x.8d6ed021.png";